import React, { useState } from 'react';
import 'styled-components/macro';
import Form, { useForm } from 'components/molecules/Form';
import Field from 'components/molecules/Field';
import Grid from 'components/atoms/Grid';
import GridCol from 'components/atoms/GridCol';
import Button from 'components/atoms/Button';
import Toast from 'components/molecules/Toast';
import businessService from 'services/businessService';
import { AuthContext } from 'context/authContext';
import { useContextHook } from 'use-context-hook';
import { StyledMidHistory, StyledCurrentMid, StyledPreviousMid } from './styles';

function UpdateBusinessMid({ onClose, business }) {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const { refetch } = useContextHook(AuthContext, ['refetch']);
  const [state, setState] = useState({});

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const { message } = await businessService.updateBusinessMid(business._id, {
        mid: state.mid,
      });

      Toast({
        type: 'success',
        message: message || 'MID updated successfully',
      });
      refetch();
      onClose();
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message ?? 'Something went wrong',
      });
    }
    setLoading(false);
  };

  const previousMids = business?.previous_mids || [];
  const currentMid = business?.mid;

  return (
    <Form form={form} onSubmit={handleSubmit} loading={loading} onTouched={_ => setState(__ => ({ ...__, ..._ }))}>
      <Grid>
        <GridCol md={12}>
          <StyledMidHistory>
            <h3>MID History</h3>

            <div>
              <h4>Current MID</h4>
              <StyledCurrentMid>{currentMid || 'No MID assigned'}</StyledCurrentMid>
            </div>

            {previousMids.length > 0 && (
              <div>
                <h4>Previous MIDs</h4>
                <div>
                  {previousMids.map((mid, index) => (
                    <StyledPreviousMid key={index}>{mid}</StyledPreviousMid>
                  ))}
                </div>
              </div>
            )}
          </StyledMidHistory>
        </GridCol>

        <GridCol md={12}>
          <Form.Item
            rules={[
              { required: true, message: 'Please enter new MID' },
              {
                pattern: /^[A-Za-z0-9]+$/,
                message: 'MID should contain only alphanumeric characters',
              },
            ]}
            name="mid"
            label="New MID"
            placeholder="Enter new MID">
            <Field />
          </Form.Item>
        </GridCol>

        <GridCol md={12}>
          <Button
            css={`
              margin-left: auto;
            `}
            loading={loading}
            type="primary"
            htmlType="submit">
            Update MID
          </Button>
        </GridCol>
      </Grid>
    </Form>
  );
}

export default UpdateBusinessMid;
